import { Action } from '@ngrx/store';
import { PrestacionAgregada } from '../models/store.model';


export const SETPRESTACION = '[PrestacionData] Agregar Prestacion';
export const UPDATEPRESTACIONCANTIDAD = '[PrestacionData] Actualizar Cantidad Prestacion';
export const DELETEPRESTACION = '[PrestacionData] Eliminar Prestacion';
export const UNSETPRESTACION = '[PrestacionData] Resetear Prestaciones';


export class SetPrestacion implements Action {
    readonly type = SETPRESTACION;
    constructor(public prestacionAgregada: PrestacionAgregada) { }
}

export class UpdatePrestacionCantidad implements Action {
    readonly type = UPDATEPRESTACIONCANTIDAD;
    constructor(public updateCantidad: { index: number; cantidad: number }) { }
}

export class DeletePrestacion implements Action {
    readonly type = DELETEPRESTACION;
    constructor(public index: number) { }
}

export class UnsetPrestacion implements Action {
    readonly type = UNSETPRESTACION;
}

export type PrestacionDataActions =
    | SetPrestacion
    | UpdatePrestacionCantidad
    | DeletePrestacion
    | UnsetPrestacion;

